var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyhome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15.5C18 17.5 20 21 20 21M4 21c2.21-5.539 6.597-7.44 9.395-8.39C15.445 11.914 17 10.217 17 7.846 17 5.17 15.02 3 12.579 3c-2.442 0-4.421 2.17-4.421 4.846 0 1.165.375 2.234 1 3.07C9.783 11.752 11 13 11 13",
    stroke: "#fff",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyhome);
export default __webpack_public_path__ + "static/media/myhome.b19dbd3592fe1490b181fc76546fb78c.svg";
export { ForwardRef as ReactComponent };